// removed by extract-text-webpack-plugin
module.exports = {"main":"main__1Xa6l","inner":"inner__2DA6j"};


//////////////////
// WEBPACK FOOTER
// ./layouts/main/style.css
// module id = HwER
// module chunks = 0